import { Component, Inject, OnDestroy, OnInit, signal, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, of, Subject, takeUntil } from 'rxjs';
import { SwiperComponent } from '../../../common/components';
import { InstaLearn, InstaLearnTopic, NodeModel } from '../../../common/models';

@Component({
    selector: 'lib-insta-topics-dialog',
    templateUrl: './insta-topics-dialog.component.html',
    styleUrls: ['./insta-topics-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InstaTopicsDialogComponent {
  public cardViewed: Subject<{ topic: InstaLearnTopic, card: InstaLearn }> = new Subject<{ topic: InstaLearnTopic, card: InstaLearn }>();

  @ViewChild(SwiperComponent) public set swiperComponent(value: SwiperComponent) {
    this._swiperComponent = value;

    this.swiperComponent?.swiper?.slideTo(this.data.activeIndex);
  }

  public get swiperComponent() {
    return this._swiperComponent;
  }

  public topics: {
    topic: InstaLearnTopic;
    cardsSource: Observable<InstaLearn[]>
  }[] = [];

  public muted = false;

  public swiperOptions = {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 0,
    loop: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      640: {
        slidesPerView: 'auto',
        spaceBetween: 0,
      }
    },
  };

  private unsubscribe: Subject<void> = new Subject();
  private _swiperComponent: SwiperComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { 
      items: { topic: InstaLearnTopic; cardsSource: Observable<InstaLearn[]> }[], 
      activeIndex?: number },
    private readonly dialogRef: MatDialogRef<InstaTopicsDialogComponent>) {}

  ngOnInit(): void {
    this.topics = this.data.items;
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public closeDialog(item: InstaLearn) {
    this.dialogRef.close(item);
  }

  public mutedChanged(muted: boolean): void {
    this.muted = muted;
  }
}
